import React from 'react'

const AddGroup = () => {
  return (
    <div>AddGroup</div>
  )
}

export default AddGroup